﻿import {translation} from "@2d-front-monorepo/core";
import {IMvvmContextState, MvvmTextInput} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, useMemo} from "react";
import UserPassword from "./UserPassword";

type ChangePassword = {
	oldPassword: string;
	password: string;
}

type ChangePasswordProps = {
	context: IMvvmContextState<ChangePassword>;
}

export default function ChangeUserPassword(props: ChangePasswordProps): JSX.Element {
	const {context} = props;
	const requireOldPassword = useMemo(() => ({required: translation(PermitTranslations.validation__old_password__required)}), []);

	return <>
		<MvvmTextInput type="password"
		               context={context}
		               property="oldPassword"
		               autoComplete="current-password"
		               label={translation(PermitTranslations.settings_page__old_password)}
		               validation={requireOldPassword}/>

		<UserPassword context={context}/>
	</>;
}
